import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import {header} from "../../../shared/headerStyle";
import Checkbox from "@mui/material/Checkbox";

function FormRow({username, handleChange, checkedRights, index}) {
    const right = checkedRights.rights?.find(r => r.username === username);
    const checkRead = right?.read ?? false;
    const checkWrite = right?.write ?? false;

    return (
        <TableRow sx={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f5f5f5' }}>
            <TableCell>{username}</TableCell>
            <TableCell>
                <Checkbox name={username} value="read" onChange={handleChange} checked={checkRead} />
            </TableCell>
            <TableCell>
                <Checkbox name={username} value="write" onChange={handleChange} checked={checkWrite} />
            </TableCell>
        </TableRow>
    );
}

function ProjectUsers({users, checkedRights, handleChange}) {
    return (
        <Box sx={{ width: '100%' }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={header}>Name</TableCell>
                        <TableCell sx={header}>Leserecht</TableCell>
                        <TableCell sx={header}>Schreibrecht</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users?.map((user, index) => (
                        <FormRow
                            key={user.username}
                            username={user.username}
                            handleChange={handleChange}
                            checkedRights={checkedRights}
                            index={index}
                        />
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}

export default ProjectUsers;
